import { Injectable } from '@angular/core';
import { Identity } from '../models/identity.model';
import { IdentityJwtPayload } from '../models/authentication.model';
import { JsonUtils } from '../utils/json.utils';

@Injectable({ providedIn: 'root' })
export class IdentityService {

  private static readonly IDENTITY_STORAGE_KEY: string = 'identity';

  private identity: Identity = {};

  get email() {
    return this.identity.email;
  }

  public getEmailInitials(): string {
    return this.identity.email.slice(0, 2).toUpperCase();
  }

  public destroyIdentity(): void {
    localStorage.removeItem(IdentityService.IDENTITY_STORAGE_KEY);
    this.identity = {};
  }

  public setIdentity(idJwtPayload: IdentityJwtPayload) {
    this.identity = new Identity();
    this.identity.email = idJwtPayload.email;
    this.identity.roles = idJwtPayload.mp_roles;
    localStorage.setItem(IdentityService.IDENTITY_STORAGE_KEY, JSON.stringify(this.identity));
  }

  public refreshIdentity(idJwtPayload: IdentityJwtPayload): void {
    this.identity.roles = idJwtPayload.mp_roles;
    localStorage.setItem(IdentityService.IDENTITY_STORAGE_KEY, JSON.stringify(this.identity));
  }

  public loadIdentity() {
    this.identity = JsonUtils.parseJsonIfValid(localStorage.getItem(IdentityService.IDENTITY_STORAGE_KEY), {});
  }

}
